module.exports = __webpack_public_path__ + "img/1_etablissement_jaune.e7ef727e.svg";